<div class="redesign-incomplete-info-warning is-flex-column">
    <div class="content-area">
        <img class="alert" src="assets/images/yellow-alert.svg" alt="warning icon" />
        <div class="text-content">
            <p *ngIf="error">{{ error }}</p>
            <ng-container [ngTemplateOutlet]="isOnline ? descriptionOnline : descriptionOffline"></ng-container>
        </div>
    </div>
    <div class="action">
        <button (click)="onSubmit()" [disabled]="!isOnline" mat-raised-button>Send Provider Update to Panel</button>
    </div>
</div>

<ng-template #descriptionOnline>
    <p>
        The selected Cellular Provider does not match the panel's selected provider.
        <br />
        Update the panel's Cellular Provider below.
    </p>
</ng-template>

<ng-template #descriptionOffline>
    <p>This panel is offline, get the panel online and then update Cellular Provider below.</p>
</ng-template>
